<template>
		<div v-if="menuOpen" @click="menuOpen = !menuOpen" class="menu-dropdown-background"></div>
  <header class="app-header">
		<div v-if="menuOpen" @click="menuOpen = !menuOpen" class="menu-dropdown-background"></div>
    <div class="header-top">
      <div class="header-left">
        <h1>{{ title }}</h1>
      </div>
      <div class="header-menu" @click.stop>
        <button @click="menuOpen = !menuOpen" class="btn menu-button" :class="{ active: menuOpen }">
          ☰ Menu
        </button>
        <div v-if="menuOpen" class="menu-dropdown">
          <button @click="navigateTo('tracker')" class="menu-item">
            <span class="menu-icon">⏳</span> Tracker
          </button>
          <button @click="navigateTo('groups')" class="menu-item">
            <span class="menu-icon">👥</span> Groups
          </button>
          <button v-if="isAdmin" @click="navigateTo('users')" class="menu-item">
            <span class="menu-icon">👤</span> Users
          </button>
          <button v-if="isAdmin" @click="navigateTo('system')" class="menu-item">
            <span class="menu-icon">🖥️</span> System
          </button>
          <button @click="navigateTo('settings')" class="menu-item">
            <span class="menu-icon">⚙️</span> Settings
          </button>
          <button @click="handleLogout" class="menu-item">
            <span class="menu-icon">🚪</span> Logout
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../composables/useAuth'

interface Props {
  title: string
}

defineProps<Props>()

const router = useRouter()
const { logout, user } = useAuth()
const menuOpen = ref(false)
const isAdmin = computed(() => user.value?.is_admin ?? false)

const navigateTo = (page: 'tracker' | 'groups' | 'settings' | 'users' | 'system') => {
  menuOpen.value = false
  switch (page) {
    case 'tracker':
      router.push('/')
      break
    case 'groups':
      router.push('/groups')
      break
    case 'users':
      router.push('/users')
      break
    case 'settings':
      router.push('/settings')
      break
    case 'system':
      router.push('/system')
      break
  }
}

const handleLogout = () => {
  menuOpen.value = false
  logout()
  router.push('/login')
}
</script>

<style scoped>
.app-header {
  background: rgb(from linear-gradient(135deg, var(--background-accent) 0%, var(--background) 100%) r g b / 0.5);
  background: linear-gradient(135deg, var(--background-accent) 0%, var(--background) 100%);
  background: linear-gradient(
    135deg, 
    rgb(from var(--background-accent) r g b / 0.8) 0%, 
    rgb(from var(--background) r g b / 0.8) 100%
  );
  backdrop-filter: blur(var(--header-footer-blur-intensity));
  /* border-bottom: 1px solid #e1e5e9; */
  padding: 1rem 0;
  position: sticky;
  top: 0;
  /* z-index: 100; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

.header-top {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left h1 {
  margin: 0;
  color: var(--accent-text-color);
  font-size: 1.5rem;
  font-weight: 600;
}

.header-menu {
  position: relative;
}

.menu-button {
	background: var(--content-background-color);
	border: 1px solid var(--content-border-color);
	color: #495057;
	padding: 0.5rem 1rem;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.9rem;
	transition: all 0.2s;
	z-index: 101;

	&.btn {
		transform: translateY(0);
	}
	
	&:hover:not(:disabled) {
		background: var(--hovered-content-background-color);
		border: 1px solid var(--hovered-content-background-color);
	}

	&.active,
	&.active:hover {
		background: var(--focussed-content-background-color);
		border-color: var(--focussed-content-background-color);
		color: var(--focussed-text-color);
	}
}

.menu-dropdown-background {
	background:var(--backgrop-color);
	backdrop-filter: blur(var(--backgrop-blur-intensity));
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
}
.menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--content-background-color);
  border: 1px solid var(--content-border-color);
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 1000;
  margin-top: 0.25rem;
}

.menu-item {
	display: block;
	width: 100%;
	padding: 0.75rem 1rem;
	background: none;
	border: none;
	text-align: left;
	cursor: pointer;
	font-size: 0.9rem;
	transition: background 0.2s;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	border-radius: 0.25em;
	& .menu-icon {
		font-size: 1.25em;
		width: 1.2em;
		text-align: center;
	}

	&:hover:not(:disabled) {
		background: var(--hovered-content-background-color);
		color: var(--hovered-text-color);
	}
}
</style>
